<template>
  <a
    :class="{[size]: size}"
    :href="shareLink"
    class="link-share"
    target="simplecast"
  >
    <template v-if="size === 'size-mini'">
      Share
    </template>
    <template v-else>
      Share Link
      <IconLink />
    </template>
  </a>
</template>

<script>
import IconLink from '../assets/svg/link.svg'
import Store from '../store'

export default {
  components: {
    IconLink
  },
  data () { return { store: Store } },
  computed: {
    shareLink () {
      return this.store.state.episode.episode_url + '?share=true'
    },
    size () { return this.store.state.size },
    uid () {
      return this.store.state.episode.legacy_token || this.store.state.episode.id
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

.link-share {
  align-items: center;
  background: transparent;
  border: solid 1px $grey-400;
  border-radius: 2px;
  color: $black-trans-800;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 7px 6px 9px;
  text-decoration: none;
  text-transform: uppercase;

  @include font-s();

  &.size-mini {
    border-color: $black-trans-800;
    opacity: .2;
    transition: opacity .2s ease-in-out;

    &:hover {
      opacity: 1;
    }
  }
  svg {
    margin-left: 5px;
    vertical-align: -4px;
  }
}
</style>
